import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-navtop',
  templateUrl: './mobile-navtop.component.html',
  styleUrls: ['./mobile-navtop.component.css']
})
export class MobileNavtopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
